<template>
  <div class="user-days-stats">
    <!-- 查询表单，移除查询天数输入框 -->
    <div class="query-form">
      <el-form :model="formData" inline label-width="100px">
        <el-form-item>
          <el-button type="primary" @click="queryData" :loading="queryLoading">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 结果卡片，只展示5个指标，新增当日注册人数 -->
    <div v-if="resultData" class="stats-card-container">
      <el-card class="stats-card">
        <template #header><span>总注册用户</span></template>
        <div class="stats-value">{{ resultData.totalUsers || 0 }}</div>
        <div class="stats-desc">指定时段累计</div>
      </el-card>
      <!-- ✅ 新增：当日注册人数 -->
      <el-card class="stats-card">
        <template #header><span>当日注册人数</span></template>
        <div class="stats-value">{{ resultData.totalZhuceUsers || 0 }}</div>
        <div class="stats-desc">选中日期新增角色</div>
      </el-card>
      <el-card class="stats-card">
        <template #header><span>当日登录</span></template>
        <div class="stats-value">{{ resultData.todayLogin || 0 }}</div>
        <div class="stats-desc">指定时段统计</div>
      </el-card>
      <el-card class="stats-card">
        <template #header><span>当日充值人数</span></template>
        <div class="stats-value">{{ resultData.todayRechargeUser || 0 }}</div>
        <div class="stats-desc">指定时段统计</div>
      </el-card>
      <el-card class="stats-card">
        <template #header><span>当日充值总额</span></template>
        <div class="stats-value">{{ Number(resultData.chargeTotal || 0).toFixed(2) }} 元</div>
        <div class="stats-desc">指定时段统计</div>
      </el-card>
    </div>
    <div v-else class="empty-tip">
      请选择服务器与时间，点击查询获取数据
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { LOG_API } from '@/utils/apiBase';
// 新增 serverName 和 selectedDate
const props = defineProps({
  serverId: {
    type: String,
    default: ''
  },
  serverName: {
    type: String,
    default: ''
  },
  selectedDate: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
})
const queryLoading = ref(false)
const resultData = ref(null)
const formData = ref({})
// 查询接口
const queryData = async () => {
  if (!props.serverId) {
    ElMessage.warning('请先选择游戏服务器')
    return
  }
  queryLoading.value = true
  try {
    const res = await axios.get(`${LOG_API}/api/drop/loginuserdata`, {
      params: {
        serverId: props.serverId,
        servername: props.serverName, // ✅ 这里传服务器名称
        time: props.selectedDate ? props.selectedDate : '所有'
      },
      timeout: 10000
    });
    if (res.data.code === 200) {
      resultData.value = res.data.data
      ElMessage.success('查询成功')
    } else {
      ElMessage.error(res.data.msg || '查询失败')
      resultData.value = null
    }
  } catch (err) {
    console.error(err)
    ElMessage.error('请求异常，获取数据失败')
    resultData.value = null
  } finally {
    queryLoading.value = false
  }
}
const resetForm = () => {
  resultData.value = null
}
</script>

<style scoped>
.query-form {
  padding: 16px;
  margin-bottom: 16px;
  background-color: #273449;
  border-radius: 6px;
}
.stats-card-container {
  display: flex;
  gap:16px;
  flex-wrap: wrap;
  padding: 0 16px 16px;
}
.stats-card {
  flex:1;
  min-width: 240px;
  background-color: #273449 !important;
  border: none;
}
:deep(.el-card__header) {
  color:#94a3b8;
  border-bottom: none;
}
.stats-value {
  font-size: 28px;
  font-weight: bold;
  color:#fff;
  margin:8px 0 4px;
}
.stats-desc {
  font-size:12px;
  color:#94a3b8;
}
.empty-tip {
  padding:30px;
  text-align:center;
  color:#94a3b8;
}
</style>
